// extracted by mini-css-extract-plugin
export default {"list":"RoutineList_list__95ZUx"};